import React from "react";

// Background
import bgTeam from "../../../images/bg/team-bg.png";

// KOT Corporate Values — Corporate Statutes, Article 17
const values = [
  { name: "Innovation", role: "New ideas that improve lives & industries" },
  { name: "Excellence", role: "Highest standards in everything we do" },
  { name: "Integrity", role: "Honest, ethical & transparent always" },
  { name: "Learning", role: "Lifelong curiosity & capability development" },
  { name: "Collaboration", role: "Shared success through partnership" },
  { name: "Respect", role: "Dignity & diversity of every individual" },
  { name: "Courage", role: "Bold decisions, lasting impact" },
  { name: "Responsibility", role: "Technology in service of humanity" },
];

const TeamSection: React.FC = () => {
  return (
    <section
      className="team pt-140 pb-150 bg_img"
      style={{ backgroundImage: `url(${bgTeam})` }}
    >
      <div className="container">
        <div className="sec-title sec-title-center text-center mb-45">
          <span className="sub-title mb-20">Our Corporate Values</span>
          <h2 className="title title-line_height">Values that guide every activity</h2>
        </div>

        <div className="row mt-none-30">
          {values.map((value, i) => (
            <div
              className="col-xl-3 col-lg-4 col-md-6 col-sm-6 mt-30"
              key={i}
            >
              <div className="xb-value-item xb-border">
                <span className="xb-value-item--num">
                  {String(i + 1).padStart(2, "0")}
                </span>
                <h2 className="xb-value-item--name">{value.name}</h2>
                <p className="xb-value-item--desc">{value.role}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TeamSection;
